// extracted by mini-css-extract-plugin
export default {"projectMemberContainer":"ProjectMemberPage_projectMemberContainer__s2wVZ","projectMemberMain":"ProjectMemberPage_projectMemberMain__1nd0B"};